module.exports = __webpack_public_path__ + "img/5.93f5151a.png";